import { get_site_auth_header } from '../auth/module.ts'
import { BACKEND_SERVER } from '../common/env.ts'
import Invoice from '../common/models/Invoice.ts'

export async function save_invoice(arg_invoice: Invoice) {
    try {
        const loc_headers = Object.assign(
            get_site_auth_header(),
            { "Content-Type": "application/json" }
        )

        const loc_invoice_to_post = {
            vendor: arg_invoice.invoice_information.vendor,
            project_NaN: arg_invoice.invoice_information.project_NaN,
            project_description: arg_invoice.invoice_information.project_description,
            customer: arg_invoice.invoice_information.customer,
            project_manager: arg_invoice.invoice_information.project_manager,
            invoice_NaN: arg_invoice.invoice_information.invoice_NaN,
            total: arg_invoice.invoice_information.total,
            line_items: arg_invoice.invoice_line_items
        }        

        const loc_invoice_repsonse = await fetch(BACKEND_SERVER + '/invoices',
            {
                method: "POST",
                headers: loc_headers,
                body: JSON.stringify(loc_invoice_to_post),
            }
        )

        if (loc_invoice_repsonse.status !== 200) {
            console.error(loc_invoice_repsonse)
        } else {
            return
        }
    } catch (error) {
        console.error(error)
    }
}

export async function search_invoice() {
    try {
        const loc_headers = get_site_auth_header()

        // const loc_invoice_to_post = {
        //     vendor: arg_invoice.invoice_information.vendor,
        //     project_NaN: arg_invoice.invoice_information.project_NaN,
        //     project_description: arg_invoice.invoice_information.project_description,
        //     customer: arg_invoice.invoice_information.customer,
        //     project_manager: arg_invoice.invoice_information.project_manager,
        //     invoice_NaN: arg_invoice.invoice_information.invoice_NaN,
        //     total: arg_invoice.invoice_information.total,
        //     line_items: arg_invoice.invoice_line_items
        // }

        const loc_search_terms = {
            purchase_order_NaN: "",
            project_NaN: "",
            vendor: "3E",
            invoice_NaN: "",
            all_parts: false,
        }

        const loc_invoice_repsonse = await fetch(BACKEND_SERVER + '/invoices/search',
            {
                headers: loc_headers,
                body: JSON.stringify(loc_search_terms),
                method: "POST"
            }
        )

        if (loc_invoice_repsonse.status !== 200) {
            console.error(loc_invoice_repsonse)
        } else {
            let loc_invoices = await loc_invoice_repsonse.json()
            loc_invoices.response_status = 200
            console.log(loc_invoices)
        }
    } catch (error) {
        console.error(error)
    }
}

export async function list_invoice_items() {
    try {
        const loc_headers = get_site_auth_header()

        // const loc_invoice_to_post = {
        //     vendor: arg_invoice.invoice_information.vendor,
        //     project_NaN: arg_invoice.invoice_information.project_NaN,
        //     project_description: arg_invoice.invoice_information.project_description,
        //     customer: arg_invoice.invoice_information.customer,
        //     project_manager: arg_invoice.invoice_information.project_manager,
        //     invoice_NaN: arg_invoice.invoice_information.invoice_NaN,
        //     total: arg_invoice.invoice_information.total,
        //     line_items: arg_invoice.invoice_line_items
        // }

        const loc_search_terms = {
            // purchase_order_NaN: "",
            // project_NaN: "",
            // vendor: "3E",
            // invoice_NaN: "",
            // all_parts: false,
        }

        const loc_invoice_items_repsonse = await fetch(BACKEND_SERVER + '/invoices/items/list',
            {
                headers: loc_headers,
                body: JSON.stringify(loc_search_terms),
                method: "POST"
            }
        )

        if (loc_invoice_items_repsonse.status !== 200) {
            console.error(loc_invoice_items_repsonse)
        } else {
            let loc_invoice_items = await loc_invoice_items_repsonse.json()
            return loc_invoice_items
        }
    } catch (error) {
        console.error(error)
    }
}

export async function list_invoices() {
    try {
        const loc_headers = get_site_auth_header()

        // const loc_invoice_to_post = {
        //     vendor: arg_invoice.invoice_information.vendor,
        //     project_NaN: arg_invoice.invoice_information.project_NaN,
        //     project_description: arg_invoice.invoice_information.project_description,
        //     customer: arg_invoice.invoice_information.customer,
        //     project_manager: arg_invoice.invoice_information.project_manager,
        //     invoice_NaN: arg_invoice.invoice_information.invoice_NaN,
        //     total: arg_invoice.invoice_information.total,
        //     line_items: arg_invoice.invoice_line_items
        // }

        const loc_search_terms = {
            // purchase_order_NaN: "",
            // project_NaN: "",
            // vendor: "3E",
            // invoice_NaN: "",
            // all_parts: false,
        }

        const loc_invoices_repsonse = await fetch(BACKEND_SERVER + '/invoices/list',
            {
                headers: loc_headers,
                body: JSON.stringify(loc_search_terms),
                method: "POST"
            }
        )

        if (loc_invoices_repsonse.status !== 200) {
            console.error(loc_invoices_repsonse)
        } else {
            let loc_invoices = await loc_invoices_repsonse.json()
            return loc_invoices
        }
    } catch (error) {
        console.error(error)
    }
}

// type SearchPartsRequest struct {
// 	SearchText        string   `json:"search_text"`
// 	VendorID          int64    `json:"vendor_id"`
//     ExistingPartNames []string `json:"existing_part_names"`
// }

// type SearchPartsResponse struct {
// 	Name               string   `json:"name"`
// 	Description        string   `json:"description"`
// }

// type DeleteRegisteredPartRequest struct{
//     RegisteredPartName  string   `json:"registered_part_name"`
// }

// type CreateOrUpdatedRegisteredPartRequestVendor struct{
//     VendorID  string   `json:"vendor_id"`
//     PartNames []string `json:"part_names"`
// }

// type CreateOrUpdatedRegisteredPartRequest struct {
//     RegisteredPartName string                                 `json:"registered_part_name"`
//     VendorsParts []CreateOrUpdatedRegisteredPartRequestVendor `json:"vendors_parts"`
// }

// type ListRegisteredPartsRequest struct {
//     SearchText string `json:"search_text"`
//     PageSize   int64  `json:"page_size"`
//     PageNumber int64  `json:"page_number"`
// }

// type ListRegisteredPartsResponseVendor struct {
//     VendorID  int64    `json:"vendor_id"`
//     PartNames []string `json:"part_names"`
// }

// type ListRegisteredPartsResponse struct {
//     Parts              map[string][]string `json:"-"`
//     RegisteredPartName string              `json:"registered_part_name"`
// }

export async function parts_search(search_text: string, vendor_id: number, existing_part_names: string[]) {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
            search_text: search_text,
            vendor_id: vendor_id,
            existing_part_names: existing_part_names,
        }

        const loc_repsonse = await fetch(BACKEND_SERVER + '/parts/search',
            {
                headers: {
                    ...loc_headers,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )

        if (loc_repsonse.status !== 200) {
            console.error(loc_repsonse)
        } else {
            let loc_repsonse_json = await loc_repsonse.json()
            return loc_repsonse_json ?? []
        }
    } catch (error) {
        console.error(error)
    }
}

export async function registered_parts_search(search_text: string, existing_part_ids: number[]) {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
            search_text: search_text,
            existing_part_ids: existing_part_ids,
        }

        const loc_repsonse = await fetch(BACKEND_SERVER + '/parts/registered/search',
            {
                headers: {
                    ...loc_headers,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )

        if (loc_repsonse.status !== 200) {
            console.error(loc_repsonse)
        } else {
            let loc_repsonse_json = await loc_repsonse.json()
            return loc_repsonse_json ?? []
        }
    } catch (error) {
        console.error(error)
    }
}

export async function delete_registered_part(registered_part_name: string) {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
            registered_part_name: registered_part_name
        }

        const loc_repsonse = await fetch(BACKEND_SERVER + '/parts',
            {
                headers: {
                    ...loc_headers,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "DELETE"
            }
        )

        if (loc_repsonse.status !== 200) {
            console.error(loc_repsonse)
        }
    } catch (error) {
        console.error(error)
    }
}

export async function create_or_edit_registered_part(registered_part_name: string, parts: object) {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
            registered_part_name: registered_part_name,
            vendors_parts: parts,
        }

        console.log('loc_request', loc_request)

        const loc_repsonse = await fetch(BACKEND_SERVER + '/parts',
            {
                headers: {
                    ...loc_headers,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )

        if (loc_repsonse.status !== 200) {
            console.error(loc_repsonse)
        }
    } catch (error) {
        console.error(error)
    }
}

export async function list_registered_parts(search_text: string, page_size: number, page_number: number) {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
            search_text: search_text,
            page_size: page_size,
            page_number: page_number,
        }

        const loc_repsonse = await fetch(BACKEND_SERVER + '/parts/list',
            {
                headers: {
                    ...loc_headers,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )

        if (loc_repsonse.status !== 200) {
            console.error(loc_repsonse)
        } else {
            let loc_repsonse_json = await loc_repsonse.json()
            return loc_repsonse_json
        }
    } catch (error) {
        console.error(error)
    }
}

export async function search_registered_parts(
    search_text: string,
    project_id: string,
    vendor: number,
    invoice_NaN: string,
    customer: string,
    project_manager: string,
    invoice_date_after: Date,
    invoice_date_before: Date,
    registered_part_ids: number[],
    return_csv: boolean,
    page_number: number,
    page_size: number
) {
    try {
        let loc_headers = get_site_auth_header()

        const loc_request = {
            search_text: search_text,
            project_id: project_id,
            vendor: vendor,
            invoice_NaN: invoice_NaN,
            customer: customer,
            project_manager: project_manager,
            registered_part_name: "",
            invoice_date_after: invoice_date_after,
            invoice_date_before: invoice_date_before,
            registered_part_ids: registered_part_ids,
            return_csv: return_csv,
            page_number: page_number,
            page_size: page_size
        }

        const loc_repsonse = await fetch(BACKEND_SERVER + '/invoice/search-products',
            {
                headers: {
                    ...loc_headers,
                    'Content-Type': "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )

        if (loc_repsonse.status !== 200) {
            console.error(loc_repsonse)
        } else if (loc_request.return_csv) {
            return await loc_repsonse.blob()
        } else {
            let loc_repsonse_json = await loc_repsonse.json()

            return {
                results: loc_repsonse_json,
                total_count: loc_repsonse.headers.get('total-count')
            }
        }
    } catch (error) {
        console.error(error)
    }
}

export async function search_invoice_list_items(
    search_text: string,
    project_id: string,
    vendor: number,
    invoice_NaN: string,
    customer: string,
    project_manager: string,
    registered_part_name: string,
    invoice_date_after: Date,
    invoice_date_before: Date,
    registered_part_ids: number[],
    return_csv: boolean,
    page_number: number,
    page_size: number
) {
    try {
        const loc_headers = get_site_auth_header()

        const loc_request = {
            search_text: search_text,
            project_id: project_id,
            vendor: vendor,
            invoice_NaN: invoice_NaN,
            customer: customer,
            project_manager: project_manager,
            registered_part_name: registered_part_name,
            invoice_date_after: invoice_date_after,
            invoice_date_before: invoice_date_before,
            registered_part_ids: registered_part_ids,
            return_csv: return_csv,
            page_number: page_number,
            page_size: page_size
        }

        const loc_repsonse = await fetch(BACKEND_SERVER + '/invoice/search-line-items',
            {
                headers: {
                    ...loc_headers,
                    'Content-Type': "application/json"
                },
                body: JSON.stringify(loc_request),
                method: "POST"
            }
        )

        if (loc_repsonse.status !== 200) {
            console.error(loc_repsonse)
        } else if (loc_request.return_csv) {
            return await loc_repsonse.blob()
        } else {
            let loc_repsonse_json = await loc_repsonse.json()

            return {
                results: loc_repsonse_json,
                total_count: loc_repsonse.headers.get('total-count')
            }
        }
    } catch (error) {
        console.error(error)
    }
}

    // SearchText            string `json:"search_text"`
    // ProjectID             string `json:"project_id"`
    // Vendor                string `json:"vendor"`
    // InvoiceNaN            string `json:"invoice_NaN"`
    // Customer              string `json:"customer"`
    // ProjectManager        string `json:"project_manager"`